import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, createVNode as _createVNode, normalizeClass as _normalizeClass, createElementBlock as _createElementBlock } from "vue"

import { cn } from '@/lib/utils'
import { Skeleton } from '@/components/ui/skeleton'
import { computed, type HTMLAttributes } from 'vue'


export default /*@__PURE__*/_defineComponent({
  __name: 'SidebarMenuSkeleton',
  props: {
    showIcon: { type: Boolean },
    class: {}
  },
  setup(__props: any) {

const props = __props

const width = computed(() => {
  return `${Math.floor(Math.random() * 40) + 50}%`;
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", {
    "data-slot": "sidebar-menu-skeleton",
    "data-sidebar": "menu-skeleton",
    class: _normalizeClass(_unref(cn)('flex h-8 items-center gap-2 rounded-md px-2', props.class))
  }, [
    (_ctx.showIcon)
      ? (_openBlock(), _createBlock(_unref(Skeleton), {
          key: 0,
          class: "size-4 rounded-md",
          "data-sidebar": "menu-skeleton-icon"
        }))
      : _createCommentVNode("", true),
    _createVNode(_unref(Skeleton), {
      class: "h-4 max-w-(--skeleton-width) flex-1",
      "data-sidebar": "menu-skeleton-text",
      style: _normalizeStyle({ '--skeleton-width': width.value })
    }, null, 8, ["style"])
  ], 2))
}
}

})